module.exports = __webpack_public_path__ + "static/media/foot_notice.ae25954e.png";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/img/score/ui_game/foot_notice.png
// module id = 207
// module chunks = 0